export const cetra_item = [
  
  {
    cetra_item_title: "Misión",
    cetra_item_text: "Coordinar, promover e implementar las diversas acciones y programas en materia de donación, disposición de órganos y tejidos de seres humanos con fines terapéuticos, así como decir y vigilar la asignación de estos en beneficio de los pacientes que lo requieran, en los sectores publico, social y privado, en un marco de transparencia, respeto, equidad y calidad.",
  },
  {
    cetra_item_title: "Visión",
    cetra_item_text: "Ser una institución rectora en el sistema estatal de salud en donación y trasplante que coordine acciones que permitan generar y concretar respuestas para satisfacer los requerimientos y necesidades de la población en menor tiempo posible, sustentando por la confianza y la actitud positiva de la comunidad hacia la donación.",
  },
  {
    cetra_item_title: "Objetivo General",
    cetra_item_text: "Cubrir el amplio rezago que existe en donación y trasplante y ser líderes en la materia con personal calificado y tecnología de vanguardia en estricto apego a la ética y la ley, con la normatividad del Centro Nacional de Trasplantes, brindando un servicio humano de alta calidad y eficiencia mediante la optimización de recursos humanos y materiales mediante un marco de transparencia, respeto, equidad y calidad.",
  },
  {
    cetra_item_links: [
    { label: "SIN DONADOR NO HAY TRANSPLANTE", url: "/Organismos/Cetra/Donadornt/Donadornt" },
    { label: "EL TRANSPLANTE Y SU PROCESO", url: "/Organismos/Cetra/TransplanteP/TransplanteP" },
    { label: "¿DUDAS SOBRE TRANSPLANTES?", url: "/Organismos/Cetra/TransFaq/TransFaq" },
    ],
  },
]